import { printLocalDatetimeWithTimezone } from 'src/products/connector/utils/printLocalDatetimeWithTimezone';
import { connectorByIdQuery } from 'src/services/DOM/queries/connectorById/__generated__/connectorByIdQuery.graphql';
import { buildCreatedStringReturn } from './model';

export const buildCreatedString = (
  sources: connectorByIdQuery['response']['connector']['sources']
): buildCreatedStringReturn => {
  if (!sources.length) {
    return 'N/A';
  }

  return printLocalDatetimeWithTimezone(
    'MMM D YYYY h:mm A',
    sources[0].createdAt
  );
};
